'use strict'

const geocode = require('./geocode');
const addressModel = require('./addressModel');
var formValidation = require('../../components/formValidation');
const { handleStateSelection, checkCoverage, showAddressErrorMessage, clearNotCoverageMessages, initPostalCodeValidation } = require('../../util/addressForm');
const { highlightInvalidFields, validateExternalNumber, validateFieldInteractive } = require('../../util/addressValidation');
const { FIELD_REGEXES, ACCOUNT_FIELD_SELECTORS } = require('../../util/constants');

let $modal = null;
let $modalMainTabsContent = null;
let $addEditAddressTabContent = null;
let $addEditAddressForm = null;
let $notificationContainer = null;
let $notificationMessage = null;
let coords = {};

/**
 * Clears the coordinates object
 * @returns {void}
 */
function clearCoordinates() {
    coords = {};
}

function disableCustomAttrTextFields(state){
    const $neighborhoodTxt = $addEditAddressForm.find('.neighborhoodTxt');
    const $cityTxt = $addEditAddressForm.find('.cityTxt');
    const $stateTxt = $addEditAddressForm.find('.stateTxt');

    $neighborhoodTxt.prop('disabled', state);
    $cityTxt.prop('disabled', state);
    $stateTxt.prop('disabled', state);
}

function fillDataWithAddressDetailsFromZipCode(addressDetails) {
    const { city, state, neighborhood, postalCode } = addressDetails;
    const $neighborhoodTxt = $addEditAddressForm.find('.neighborhoodTxt');
    const $cityTxt = $addEditAddressForm.find('.cityTxt');
    const $state = $addEditAddressForm.find('.stateTxt');
    const $postalCodeTxt = $addEditAddressForm.find('.postalcodeTxt');

    if (!neighborhood && $neighborhoodTxt.val()) {
        $neighborhoodTxt.val('');
        $neighborhoodTxt.parent().removeClass('filled');
    }

    if (!city && $cityTxt.val()) {
        $cityTxt.val('');
        $cityTxt.parent().removeClass('filled');
        $cityTxt.prop('disabled', false);
    }

    if (neighborhood) {
        $neighborhoodTxt.val(neighborhood);
        $neighborhoodTxt.parent().addClass('filled');
    }

    if (city) {
        $cityTxt.val(city);
        $cityTxt.parent().addClass('filled');
        $cityTxt.prop('disabled', true);
    }

    if (state) {
        handleStateSelection(state, $state);
    }

    if (postalCode) {
        $postalCodeTxt.val(postalCode);
        $postalCodeTxt.parent().addClass('filled');
    }
}

function ResetShippingMethodsModalTabState() {
    $('.modal-address-form').data('is-invalid-edit', false);
    $addEditAddressTabContent.addClass('closing').removeClass('show');

    setTimeout(() => {
        $modalMainTabsContent.removeClass('d-none');
        $addEditAddressTabContent.addClass('d-none').removeClass('closing');
        $addEditAddressForm.empty();
    }, 300);
}

function ShowAddEditAddressTabContent(response, showErrors) {
    $addEditAddressForm.append(response);
    $('.modal-address-form').data('is-invalid-edit', !!showErrors);
    $modalMainTabsContent.addClass('d-none');
    $addEditAddressTabContent.removeClass('d-none');
    void $addEditAddressTabContent[0].offsetWidth;
    $addEditAddressTabContent.addClass('show');

    const $formControls = $addEditAddressForm.find('.form-control');
    $(document).trigger('initDynamicForm', [$formControls]);
    initAutocomplete();

    if (showErrors) {
        var $form = $addEditAddressForm.find('.modal-address-form');
        highlightInvalidFields($form);
    }
}

function handleShowAddAddressTabClick(e) {
    const addAddressUrl = $(this).data('add-address-url');
    $modal.spinner().start();

    e.preventDefault();
    clearCoordinates();

    $.ajax({
        url: addAddressUrl,
        method: 'GET',
        success: function (response) {
            $modal.spinner().stop();
            ShowAddEditAddressTabContent(response);
            var $form = $('.modal-address-form');
            formValidation.initOnKeypressValidation($form, '[name*="_postalCode"]', /[0-9]/, /\D/g);
        },
        error: function (xhr, status, error) {
            $modal.spinner().stop();
            console.error('Error al cargar la dirección');
        }
    });
}

function handleEditAddressClick(e) {
    e.preventDefault();

    clearCoordinates();
    var $card = $(this);
    var selectedAddress = $card.data('address-info');
    var editAddressUrl = $card.data('edit-address-url');
    var showErrors = $card.hasClass('address-invalid');
    $modal.spinner().start();
    $.ajax({
        url: editAddressUrl,
        data: { addressId: selectedAddress.name },
        method: 'GET',
        success: function (response) {
            $modal.spinner().stop();
            ShowAddEditAddressTabContent(response, showErrors);
        },
        error: function (xhr, status, error) {
            $modal.spinner().stop();
            // Error loading address
        }
    });
}

async function handleAddEditAddressCall($form) {
    disableCustomAttrTextFields(false);

    Object.keys(FIELD_REGEXES).forEach(function (fieldName) {
        var $field = $form.find(ACCOUNT_FIELD_SELECTORS[fieldName]);
        if ($field.length) {
            validateFieldInteractive($field, FIELD_REGEXES[fieldName], fieldName !== 'interiorNumber');
        }
    });

    validateExternalNumber($form);
    if ($form.find('#externalNumber').hasClass('is-invalid')) {
        return;
    }

    let url = $form.attr('action');
    const formData = $form.serializeArray();
    const addressDetails = geocode.buildAddressDetailsFromForm($form);
    const postalCode = geocode.getPostalCodeFromForm($form);
    const place = await geocode.fetchPlaceFromAddress(addressDetails, postalCode);
    if (place && place.postalCodeMismatch) {
        showAddressErrorMessage($form, { isTechnicalError: false, errorMsg: $form.data('postal-code-mismatch-msg') });
        return;
    }
    if (place) {
        coords = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };

        const coverageResult = await checkCoverage(place, $form, 'editAddress');
        if (!coverageResult.hasCoverage) {
            showAddressErrorMessage($form, coverageResult);

            return;
        }

        if (typeof coords !== 'undefined' && coords.lat && coords.lng) {
            formData.push({ name: 'latitude', value: coords.lat });
            formData.push({ name: 'longitude', value: coords.lng });
        }

        clearErrors();

        $modal.spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $.param(formData),
            success: function (data) {
                if (!data.success) {
                    $modal.spinner().stop();
                    formValidation($form, data);
                } else {
                    if (data.setDefault) {
                        $('.modal-address-form').data('is-invalid-edit', false);
                        $(document).trigger('handleSelectAndRenderSelectedDeliveryAddress', data.address);

                        return;
                    }

                    if ($('.modal-address-form').data('is-invalid-edit')) {
                        $(document).trigger('handleInitSavedAddressesSection', data.address.name);
                        $('.modal-address-form').data('is-invalid-edit', false);
                    } else {
                        $(document).trigger('handleInitSavedAddressesSection');
                    }

                    ResetShippingMethodsModalTabState();
                    $modal.spinner().stop();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $modal.spinner().stop();
            }
        });
    }
}

/**
 * Removes informative errores
 * @requires jQuery
 * @returns {void}
 */
function clearErrors() {
    $notificationMessage.text('');
    $notificationContainer.addClass('d-none');
}

/**
* HandleDeliveryPlaceChanged
* @requires jQuery
* @param {Object} autocomplete Google autocomplete
* @returns {void}
**/
function handleDeliveryPlaceChanged (autocomplete) {
    clearErrors();
    const place = autocomplete.getPlace();

    if (place.geometry) {
        coords = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        };
        if (place.address_components) {
            const addressDetails = addressModel.getAddressComponents(place);
            fillDataWithAddressDetailsFromZipCode(addressDetails);
        }
    }
    else {
        showError($deliveryInput.attr('data-error-geometry'));
    }
}

/**
 * Function to get the selected delivery address based on the global address details.
 * @param {Object} globalAddressDetails - The global address details object containing geometry and address components.
 * @returns {Object|null} The selected delivery address object, or null if geometry is not available.
 */
function getSelectedDeliveryAddressModel(globalAddressDetails) {
    let selectedDeliveryAddress = null;

    if (globalAddressDetails.geometry) {
        selectedDeliveryAddress = {
            name: '',
            addressDetails: '',
            lat: globalAddressDetails.geometry.location.lat(),
            lng: globalAddressDetails.geometry.location.lng()
        };

        if (globalAddressDetails.address_components) {
            const { addressName, addressDetails, zipCode } = addressModel.formatAddressComponents(globalAddressDetails);

            selectedDeliveryAddress.name = addressName;
            selectedDeliveryAddress.addressDetails = addressDetails;
            selectedDeliveryAddress.zipCode = zipCode;
        }
    } else {
        showError($deliveryInput.attr('data-error-geometry'));
    }

    return selectedDeliveryAddress;
}

/**
    * This function starts the engine for the autocomplete suggestions in the delivery address input
    * @requires jQuery
    * @returns {void}
    **/
function initAutocomplete() {
    geocode.initAutocomplete($addEditAddressForm.find('.postalcodeTxt'), handleDeliveryPlaceChanged);
}

function initTabsControls () {
    const btnBack = $addEditAddressTabContent.find('.add-address-btn-back');
    btnBack.on('click', function () {
        ResetShippingMethodsModalTabState();
    });

    $addEditAddressTabContent.find('.btnClose').on('click', function() {
        ResetShippingMethodsModalTabState();
        $(document).trigger('handleShippingMethodsModalClose');
    });

    //inits postal code listener

    $(document).on('submit', 'form.modal-address-form', function (e) {
        var $form = $(this);
        e.preventDefault();

        handleAddEditAddressCall($form);

        return false;
    })

    $(document).on('keyup', '.modal-address-form input[type="text"], .modal-address-form input[type="tel"], .modal-address-form textarea', function () {
        var $form = $(this).closest('form');
        if ($form.find('.postalcodeTxt').hasClass('address-form-error')) {
            clearNotCoverageMessages($form);
        }
    });

    Object.keys(FIELD_REGEXES).forEach(function (fieldName) {
        var selector = '.modal-address-form ' + ACCOUNT_FIELD_SELECTORS[fieldName];
        $(document).on('input blur', selector, function () {
            var $form = $(this).closest('.modal-address-form');
            var $field = $form.find(ACCOUNT_FIELD_SELECTORS[fieldName]);
            if ($field.length) {
                validateFieldInteractive($field, FIELD_REGEXES[fieldName], fieldName !== 'interiorNumber');
            }
        });
    });

    $(document).on('input blur', '.modal-address-form #externalNumber', function () {
        var $form = $(this).closest('.modal-address-form');
        validateExternalNumber($form);
    });

    initPostalCodeValidation($addEditAddressForm);
}

/**
 * Initialize the delivery tab
 * @requires jQuery
 * @param {jQuery} $modal modal jquery object
 * @returns {void}
 */
function initTab($mainModal) {
    $modal = $mainModal;
    $modalMainTabsContent = $modal.find('.modal-main-content.shipping-methods');
    $addEditAddressTabContent = $modal.find('.modal-main-content.addoredit-address-content');
    $addEditAddressForm = $addEditAddressTabContent.find('.address-form-section');
    $notificationContainer = $addEditAddressTabContent.find('.notification--error').first();
    $notificationMessage = $addEditAddressTabContent.find('.notification-message').first();

    initTabsControls();
}

module.exports = {
    initTab,
    initAutocomplete,
    handleShowAddAddressTabClick,
    handleEditAddressClick,
    getSelectedDeliveryAddressModel,
};
